<button mat-raised-button aria-label="Exportar Datos a Excel"
  type="button" color="primary"
  class="{{cssClass}}"
  [disabled]="disabled"
  (click)="clickButton($event)"
  matTooltip="Exportar Datos a Excel">
  <i class="fa fa-lg fa-file-excel-o" aria-hidden="true"></i> {{ 'Exportar datos' | translate }}
</button>
